


















































































































import Vue from 'vue';

import { MDCList } from '@material/list';
import { MDCDrawer } from '@material/drawer';

import AuthManager, { AuthManagerClass } from '../../libs/authentication';

class Data {
  public authManager: AuthManagerClass;

  public drawer: MDCDrawer = {} as MDCDrawer;

  constructor(activePanel: string) {
    this.authManager = AuthManager;
  }
}

export default Vue.extend({
  name: 'settings',
  data() {
    return new Data(this.$route.params.panel);
  },
  mounted() {
    this.setSelectedMenu();

    const mainContentEl = this.$el.querySelector('.main-content');
    this.drawer = MDCDrawer.attachTo(this.$el.querySelector('.mdc-drawer') as HTMLElement);

    const listEl = this.$el.querySelector('.mdc-drawer .mdc-list') as HTMLElement;
    listEl.addEventListener('click', (event) => {
      this.drawer.open = false;
    });
  },
  beforeDestroy() {
    this.drawer.destroy();
  },
  methods: {
    setSelectedMenu() {
      const links = this.$el.querySelectorAll('a') as NodeListOf<HTMLAnchorElement>;
      for (const link of links) {
        const url = new URL(link.href);
        if (this.$route.path === url.hash.slice(1)) {
          link.classList.add('mdc-list-item--activated');
          return;
        }
      }
    },
    openMenu() {
      this.drawer.open = true;
    },
  },
});
